<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card shadow-0 text-center" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">

    <div class="card-header bg-dark header-elements-inline px-0 pb-1" style="border:none;">
      <div class="row" style="width:100%;">
        <div class="col-10 pl-3 text-left pt-1" style="font-size:10px;">
          {{$t('workload')}}
        </div>
        <div class="col-2 pt-1" style="text-align:right;line-height:10px;padding-right:0px">
          <a class="list-icons-item" @click="removeMe" data-action="remove" style="margin-top:-4px;"></a>
        </div>
        <div class="col-12 pl-3 text-left">
          <h6 class="card-title" style="text-transform:uppercase;">{{$store.translate('team')}}: {{config.text}}</h6>
        </div>
      </div>
    </div>

    <div class="card-body p-0 m-0">
      <div class="row p-0 m-0">
        <div class="col p-0 m-0" style="min-height:170px;">
          <simple-pie-chart ref="chart" v-if="hasData == true" height="170px" width="170px"></simple-pie-chart>
          <img v-if="hasData == false" src="/Images/pie-diagram.png" width="100" height="100"  style="margin-top:10px;" />
          <div v-if="hasData == false">No data</div>
        </div>
      </div>
    </div>

  </div>



</template>

<script>

  import PieDiagram from '../../charts/simple-pie-chart.vue'
  var hasData = false;

  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null

  }


  var teamMembers = [];
  var teamId = 0;
  export default {
    name: "display-team-workload",
    components: {
      PieDiagram
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        teamMembers,
        teamId,
        config,
        hasData
      };
    },

    methods: {
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
    
      setConfig(config) {      
        this.config = config;
        this.teamId = config.data.toString();
      },
      recalculate(data) {
        this.hasData = false;
        var teamAssignments = data.TeamAssignments;
        if (teamAssignments[this.config.data + "-total"] != null) {
          this.hasData = true;
          var labels = [];
          var items = [];
          var totalKeys = [];

          for (var key in teamAssignments) {
            totalKeys.push(key);
          }

          for (var key in teamAssignments) {

            if (!teamAssignments.hasOwnProperty(key)) continue;

            if (key != null && key.indexOf(this.config.data + "-userassignment") == 0) {
              var user = key.split('-')[2];
              if (user != null && user != "") {
                var count = teamAssignments[key];
                labels.push(user);
                items.push(count);
              }
            }
          }

          this.$refs.chart.setData(labels, items);
        }
      }
    },
    computed: {

    },
    mounted() {
      this.$refs.chart.setData(["done", "started", "created"], [0, 0, 0]);
      vm.$root.$on('statistics', this.recalculate);
      vm.$emit('doSearch');
    },

    created: function () {

    },

    watch: {     
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .table td {
    padding: 3px !important;
    padding-top:5px;
    border-bottom: 1px solid #ddd;
    border-top: 0px solid #ddd;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-team-workload.vue